module.exports = __webpack_public_path__ + "img/qcr图像识别.f8560cfb.jpg";